import { createColumnHelper } from '@tanstack/react-table';

import { DecoratedRegistry } from '../types';

export const columnHelper = createColumnHelper<DecoratedRegistry>();
